import { ProjectAccessAction, ProjectAccessActionTypes } from '@completion/actions';
import { ProjectAccess, ProjectAccessAssignmentMask, ProjectAccessRoles } from '@completion/models';

export const initialState: ProjectAccessState = {
  projectAccess: null,
  role: ProjectAccessRoles.READ_ONLY,
  projectAccessList: null,
  projectAccessMasks: null,
  projectSignatureMasks: null,
};

export interface ProjectAccessState {
  projectAccess: ProjectAccess;
  role: ProjectAccessRoles;
  projectAccessList?: Array<ProjectAccess>;
  projectAccessMasks?: ProjectAccessAssignmentMask[] | null;
  projectSignatureMasks?: ProjectAccessAssignmentMask[] | null;
}

export function projectAccessReducer(state: ProjectAccessState = initialState, action: ProjectAccessAction): ProjectAccessState {
  switch (action.type) {
    case ProjectAccessActionTypes.ProjectAccessLoadSuccess:
      return {
        ...state,
        projectAccess: action.projectsAccess,
        role: ProjectAccessRoles[action.projectsAccess.role],
      };
    case ProjectAccessActionTypes.ProjectAccessListLoadSuccess:
      return {
        ...state,
        projectAccessList: action.projectsAccessList,
      };
    case ProjectAccessActionTypes.ProjectAccessMasksLoadSuccess:
      return {
        ...state,
        projectAccessMasks: action.masks,
      };
    case ProjectAccessActionTypes.ProjectAccessMasksUpdateSuccess: {
      const existing = state.projectAccessMasks || [];
      const updated = action.mask;
      const index = existing.findIndex((m) => m && m.projectAccessId === updated.projectAccessId);
      const nextMasks =
        index === -1
          ? [...existing, updated]
          : [...existing.slice(0, index), { ...existing[index], ...updated }, ...existing.slice(index + 1)];
      return {
        ...state,
        projectAccessMasks: nextMasks,
      };
    }
    case ProjectAccessActionTypes.ProjectSignatureMasksLoadSuccess:
      return {
        ...state,
        projectSignatureMasks: action.masks,
      };
    case ProjectAccessActionTypes.ProjectSignatureMasksUpdateSuccess: {
      const existingSig = state.projectSignatureMasks || [];
      const updatedSig = action.mask;
      const indexSig = existingSig.findIndex((m) => m && m.projectAccessId === updatedSig.projectAccessId);
      const nextSigMasks =
        indexSig === -1
          ? [...existingSig, updatedSig]
          : [...existingSig.slice(0, indexSig), { ...existingSig[indexSig], ...updatedSig }, ...existingSig.slice(indexSig + 1)];
      return {
        ...state,
        projectSignatureMasks: nextSigMasks,
      };
    }
    case ProjectAccessActionTypes.ProjectAccessLocalUpdate: {
      const updated = action.projectAccess;
      const list = state.projectAccessList || [];
      const idx = list.findIndex((pa) => pa && pa.id === updated.id);
      const nextList = idx === -1 ? [...list, updated] : [...list.slice(0, idx), { ...list[idx], ...updated }, ...list.slice(idx + 1)];
      return {
        ...state,
        projectAccessList: nextList,
      };
    }
    default:
      return state;
  }
}
